import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {SelectOption} from "../../classes/select-option";
import {Observable, Subscription} from "rxjs";
import { NgClass, NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatSelect, MatOption, MatError } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { ProgramSearchFilterPipe } from '../../../components/accreditation/evaluator-management/evaluators-list/program-search-filter.pipe';

@Component({
    selector: 'app-weave-select-search',
    templateUrl: './weave-select-search.component.html',
    styleUrls: ['./weave-select-search.component.scss'],
    imports: [NgClass, MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatSelectSearchComponent, NgIf, MatError, ProgramSearchFilterPipe]
})
export class WeaveSelectSearchComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() options: SelectOption[];
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() required: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() multiple: boolean = false;
  @Input() minlength: number = 0;
  @Input() hideRequiredMarker: boolean = false;
  @Input() onModelChange: Observable<string> = new Observable<string>();
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  searchCtrl: string = "";

  model: string;
  selectedOption: SelectOption;
  subscription: Subscription;

  tempValue: any;
  id: string = "";

  constructor() {}

  ngOnInit() {
    this.model = this.data;
    this.tempValue = this.data;
    this.id = "weave-select" + Math.floor(Math.random() * 1000);
    this.subscription = this.onModelChange.subscribe(value => {
      this.model = value;
    });
  }

  onFocusOut() {
    this.selectedOption = this.options.find(option => option.value === this.model);
    this.focusOut.emit(this.model);
  }

  undo() {
    this.data = this.tempValue;
    this.model = this.tempValue;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
